// Import packages
import React, {Suspense, useEffect} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import {Provider, useDispatch, useSelector} from "react-redux";
import {persistor, store} from "./redux/store";
import {PersistGate} from "redux-persist/integration/react";

// Import assets
import './styles/layout.scss';

// Import Components
import Dashboard from './pages/Dashboard';
import LogIn from "./pages/Authorization/LogIn/LogIn";
import Registration from "./pages/Authorization/Registration/Registration";
import OIDCAuth from "./shared/features/oidc";
import SetTitleComponent from "./shared/features/productName.jsx";
import {ROUTERS_MAP} from "./utils/routes";
import {ManageDataPage} from "./pages/ManageData";
import ToastLayout from "./modules/Toast/Toast";
import {scrollTop} from "./utils/helperFunctions";
import {NotesPage} from "./pages/Notes";
import {IntegrationsPage} from "./pages/Integrations";
import AiTeamsPage from "./pages/AiTeams/AiTeamsPage";
import TourBlock from "./modules/Tour/TourBlock";
import ConnectCalendarPage from "./pages/ConnectCalendarPage/ConnectCalendarPage";
import TourTwoStep from "./modules/Tour/components/TourTwoStep/TourTwoStep";
import TourThreeStep from "./modules/Tour/components/TourThreeStep/TourThreeStep";
import TourFourStep from "./modules/Tour/components/TourFourStep/TourFourStep";
import TourFiveStep from "./modules/Tour/components/TourFiveStep/TourFiveStep";
import TourSevenStep from "./modules/Tour/components/TourSevenStep/TourSevenStep";
import Users from "./pages/Dashboard/containers/Users";
import PrivateRouteWrapper from "./routers/PrivateRouteWrapper";
import CopilotPage from "./pages/AiTeams/Copilot/CopilotPage";
import ExtensionDetector from "./modules/ExtensionDetector/ExtensionDetector";

function App() {
    const suspenseFallback = (
        <div className="suspense-fallback">
            <p>Loading...</p>
        </div>
    );

    useEffect(()=>{
        scrollTop();
    }, [])

    return (
        <Suspense fallback={suspenseFallback}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <SetTitleComponent/>
                    <ToastLayout>
                        <Switch>
                            <OIDCAuth>
                                <Route
                                    exact strict={true}
                                    path="/"
                                    render={() =>
                                        <PrivateRouteWrapper>
                                            <CopilotPage />
                                        </PrivateRouteWrapper>
                                    }
                                />
                            <Route path={ROUTERS_MAP.LOGIN} component={LogIn}/>
                            <Route path={ROUTERS_MAP.CONNECT_CALENDAR} component={ConnectCalendarPage}/>
                            <Route path="/registration" component={Registration}/>
                            <Route path="/dashboard" component={Dashboard}/>
                            <Route
                                path="/ai-teams"
                                render={() =>
                                    <PrivateRouteWrapper>
                                        <AiTeamsPage />
                                    </PrivateRouteWrapper>
                                }
                            />
                            <Route path={ROUTERS_MAP.NOTES} component={NotesPage}/>
                            <Route path={ROUTERS_MAP.INTEGRATIONS} component={IntegrationsPage}/>
                            <Route strict={true} path={ROUTERS_MAP.MANAGE_DATA} component={ManageDataPage}/>
                            <Route path={`/users`} component={Users}/>

                                {/*                         <Route path="*"> */}
    {/*                             <Redirect to="/dashboard"/> */}
    {/*                         </Route> */}
                                <TourTwoStep/>
                                <TourThreeStep/>
                                <TourFourStep/>
                                <TourFiveStep/>
                                <TourSevenStep/>
                            </OIDCAuth>
                        </Switch>
                        <TourBlock/>
                    </ToastLayout>
                    <ExtensionDetector/>
                </PersistGate>
            </Provider>
        </Suspense>
    );
}

export default App;
